import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, useLocation, useParams } from 'react-router-dom';

import { BALL, FLIGHTS, GAME, LIVE_PRACTICE, PAST_GAME, PAST_PRACTICE, PRACTICE } from '../../../../config/constants';
import {
  getTabSelectorLabel,
  isCC,
  isNCAA,
  isNCAAAllSports,
  isTA,
  routeIsGame,
  routeToEventType,
  shouldDisplayPracticeViewer
} from '../../../../helpers';
import { useDataEventsState, useUserState } from '../../../../store/hooks';
import { BasicFilterPropsType } from '../type';

export const TabSelector = ({ show, open, close }: BasicFilterPropsType) => {

  const params = useParams<{ id: string }>();
  const { pathname, state } = useLocation();
  const eventType = routeToEventType(pathname);
  const currentLabel = getTabSelectorLabel(params);
  const user = useUserState();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const { dataEvent: data } = useDataEventsState();
  const [selected, setSelected] = useState(currentLabel);
  const now = new Date();
  const currentTimestamp = now.getTime();
  useEffect(() => {
    if (currentLabel) {
      setSelected(currentLabel);
    }
  }, [currentLabel]);

  const changePage = (page: string, tab?: string) => {
    const params = pathname.split('/').slice(0, 4);
    if (routeIsGame(pathname)) {
      params.push(pathname.split('/')[4]);
    }
    params.push(page);
    if (page === 'performance' || page === BALL) {
      if (tab) {
        params.push(tab);
      }
      params.push('page');
    }
    return params.join('/');
  };


  return (
    <Dropdown className="btn-tabs" show={show} onToggle={show ? close : open}>
      <Dropdown.Toggle id="current-view-selector" className="btn-blue">
        <label>CURRENT VIEW</label>
        {selected}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {!isMobile && data.meta.type !== LIVE_PRACTICE && (
          <Link
            to={{ pathname: changePage('performance', 'expanded'), state }}
            className="dropdown-item"
            id="tab-selector-all-metrics"
            onClick={close}
          >
            All Metrics
          </Link>
        )}
        <>
          {eventType === PRACTICE && (
            <Link
              to={{ pathname: changePage('performance', 'condensed'), state }}
              className="dropdown-item"
              onClick={close}
              id="tab-selector-live-metrics"
            >
              Live Metrics
            </Link>
          )}
          
            <Link
              to={{
                pathname: changePage(BALL, FLIGHTS),
                state,
                search: isMobile? '?view=byPlayer' : data.meta.type === LIVE_PRACTICE ? '?view=speedZone' : '?view=byPlayer'
              }}
              className="dropdown-item"
              id="tab-selector-ball-metrics"
              onClick={close}
            >
              Ball Metrics
            </Link>
        
        </>
        {!isMobile && (data.meta.type === PAST_PRACTICE || (data.meta.type === PAST_GAME && isCC(user))) && (
          <Link
            to={{ pathname: changePage('report'), state }}
            className="dropdown-item"
            id="tab-selector-reporting"
            onClick={close}
          >
            Reporting
          </Link>
        )}
        {!isMobile && isCC(user) && eventType === PRACTICE &&(
            <Link
            to={{ pathname: changePage('combine') }}
            className="dropdown-item"
            id="tab-selector-combine"
            onClick={close}
          >
              Combine Logger
            </Link>
          )}
          {isMobile && isCC(user) && eventType === PRACTICE &&(
            <Link
            to={{ pathname: changePage('event') }}
            className="dropdown-item"
            id="tab-selector-event"
            onClick={close}
          >
              Event Logger
            </Link>
          )}
          
        {!isMobile && (eventType === PRACTICE || (eventType === GAME && isCC(user)))  && shouldDisplayPracticeViewer(data) && (
          <Link
            to={{ pathname: changePage('map'), state }}
            className="dropdown-item"
            id="tab-selector-practice-viewer"
            onClick={() => close()}
          >
            Practice Viewer
          </Link>
        )}
          {!isMobile && eventType === PRACTICE  && (
          <Link
            to={{ pathname: changePage('tracking'), state }}
            className="dropdown-item"
            id="tab-selector-practice-tracking"
            onClick={close}
          >
           Practice Tracking
          </Link>
        )}
        {((isCC(user) || isTA(user) || isNCAAAllSports(user)) && eventType === PRACTICE) && (
          <Link
            to={{ pathname: changePage('manage'), state }}
            className="dropdown-item"
            id="tab-selector-practice-manager"
            onClick={close}
          >
           Practice Manager
          </Link>
        )}
         {((isCC(user)) && ((eventType === 'game' && data.meta.startTime <= currentTimestamp  ))) && (
          <Link
            to={{ pathname: changePage('game_manage'), state }}
            className="dropdown-item"
            id="tab-selector-game-manager"
            onClick={close}
          >
           Game Manager
          </Link>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TabSelector;
